import Cookies from 'universal-cookie';

export const createCookies = (data?: string) => new Cookies(data);
